import React from 'react';
import { ResultTableTitle } from './ReportEffectResults.styles';
import { useReportContext } from '../../../../hooks/useReport';
import EffectReportTemplate from '../../SharedEffectReportComponents/EffectReportTemplate/EffectReportTemplate';

const ReportEffectResults = () => {
  const {
    structuredEffectData: { results },
  } = useReportContext();

  const order = ['EFFECT INPUT', 'EFFECT PROCESSES', 'EFFECT EMERGENT STATES', 'EFFECT OUTPUT'];

  const sortedResults = Object.values(results).sort((a, b) => {
    return order.indexOf(a.type) - order.indexOf(b.type);
  });

  return (
    <ResultTableTitle>
      {sortedResults.map(item => (
        <EffectReportTemplate key={item.type} data={item} />
      ))}
    </ResultTableTitle>
  );
};

export default ReportEffectResults;
